module.exports = __webpack_public_path__ + "static/media/HCMM192.2f4a60cb.jpg";